module.exports = __webpack_public_path__ + "static/media/QA.5393ff29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/QA.svg
// module id = 2247
// module chunks = 7